<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>

    <navbar v-if="showNavbar" :docsName="docsName" />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-shortkey.once="['ctrl', 's']"
                    v-if="editable || isAdmin"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    :title="
                      invalid ? $t('global.notallfieldsfilledcorrectly') : ''
                    "
                    @shortkey="
                      !invalid
                        ? speichern()
                        : $notify({
                            type: 'error',
                            title: $t('global.actionunsuccessful'),
                            text: $t('global.notallfieldsfilledcorrectly'),
                          })
                    "
                  >
                    {{ $t("global.save") }}
                  </button>

                  <button
                    v-if="editable"
                    class="btn btn-primary mr-2"
                    @click="abbrechen"
                  >
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />
                    {{ $t("global.tolist") }}
                  </button>

                  <button
                    class="btn btn-primary mr-2"
                    @click="neueMail"
                    v-if="
                      berechtigungen.m_korrespondenz.create &&
                      $CONST('CONFIG').APPTYPE != 'DESKA'
                    "
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-envelope-open-text"
                      class="mr-2"
                    />
                    <span>{{ $t("global.sendemail") }}</span>
                  </button>

                  <button
                    class="btn btn-primary mr-2"
                    @click="neueKorrespondenz"
                    v-if="
                      berechtigungen.m_korrespondenz.create &&
                      $CONST('CONFIG').APPTYPE != 'DESKA'
                    "
                  >
                    <font-awesome-icon icon="fa-duotone fa-memo" class="mr-2" />
                    <span>{{ $t("global.newcorrespondence") }}</span>
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="editable"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-trash"
                      class="mr-2"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- START linke Seite -->
        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <div class="row">
            <div class="col-xl-12">
              <firmenangaben
                :id="id"
                :firma="firma"
                :roles="roles"
                :editable="editable"
                :auswahlwerte="auswahlwerte"
                :key="personalAngabenKey"
                @rolesChanged="computeRoles"
                @bildUpdated="ladeFirma(id)"
              />
            </div>
            <div class="col-xl-12" v-if="true">
              <betriebsangaben :betrieb="firma" :editable="editable" />
            </div>

            <!-- START Hof -->
            <div class="col-xl-12" v-if="true">
              <weitere-angaben :firma="firma" :editable="editable" />
            </div>

            <!-- ENDE Hof -->
          </div>
        </div>
        <!-- ENDE linke Seite -->

        <!-- START rechte Seite -->
        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <div class="row">
            <!-- <div class="col-xl-12">
              <abteilungen
                :editable="editable"
                :abteilungen="firma.abteilungen"
                @abteilungLoeschen="abteilungLoeschen"
                @abteilungHinzufuegen="abteilungHinzufuegen"
              />
            </div> -->
            <div class="col-xl-12">
              <kommunikationsangaben
                :firma="firma"
                :editable="editable"
                @commChanged="commChanged"
              />
            </div>
            <div class="col-xl-12" v-if="true">
              <familienangaben :familie="firma" :editable="editable" />
            </div>
            <!-- START Hof -->
            <div class="col-xl-12" v-if="true">
              <allgemeine-einsatzangaben
                :einsatz="firma"
                :editable="editable"
              />
            </div>
            <div class="col-xl-12" v-if="isZeitbetrieb">
              <zeitbetriebsangaben :firma="firma" :editable="editable" />
            </div>
            <div class="col-xl-12" v-if="isPartnerschule">
              <schulpartnerschaft :firma="firma" :editable="editable" />
            </div>
            <div class="col-xl-12" v-if="true">
              <interne-angaben :firma="firma" :editable="editable" />
            </div>
            <!-- ENDE Hof -->
          </div>
        </div>
        <!-- ENDE rechte Seite -->

        <!-- HEADER DER REITER -->

        <div v-if="id && $CONST('CONFIG').APPTYPE != 'DESKA'" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 p-0">
              <ul class="nav nav-tabs mt-3 fs-28">
                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 0 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 0 },
                    }"
                    >{{ $t("global.contactinformation") }}
                  </router-link>
                </li>

                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 1 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 1 },
                    }"
                    >{{ $t("global.relationships") }}
                  </router-link>
                </li>

                <li
                  v-show="firma && berechtigungen.m_finanzen.read"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 2 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 2 },
                    }"
                    >{{ $t("global.bankdetails") }}
                  </router-link>
                </li>

                <li
                  v-show="firma && berechtigungen.m_finanzen.read"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 3 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 3 },
                    }"
                    >{{ $t("global.invoices") }}
                  </router-link>
                </li>

                <li
                  v-show="firma && berechtigungen.m_korrespondenz.read"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 4 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 4 },
                    }"
                    >{{ $t("global.correspondence") }}
                  </router-link>
                </li>

                <li
                  v-show="firma && berechtigungen.m_korrespondenz.read"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 5 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 5 },
                    }"
                    >{{ $t("global.email") }}
                  </router-link>
                </li>

                <li
                  v-show="firma && berechtigungen.m_dokumente.read"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 6 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 6 },
                    }"
                    >{{ $t("global.documents") }}
                  </router-link>
                </li>

                <li
                  v-show="firma && berechtigungen.m_notizen.read"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 7 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 7 },
                    }"
                    >{{ $t("global.notes") }}
                  </router-link>
                </li>

                <li
                  v-show="firma"
                  class="nav-item"
                >
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 8 }"
                    :to="{
                      name: 'FirmaNewViva',
                      params: { id: id, anzeige: 8 },
                    }"
                    >{{ $t("global.voucher") }}
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="col-xl-12 p-0">
              <div class="tab-container p-3">
                <div v-show="anzeige === 0">
                  <kontaktreiter
                    :firma="id"
                    :key="kontaktkey"
                    :editable="editable"
                    :standorte="firma.standorte"
                    :shown="anzeige == 0 ? true : false"
                    @added="mailAdresseHinzufuegen"
                    @updatekontakte="kontaktegeaendert"
                  />
                </div>

                <div v-show="anzeige === 1">
                  <beziehung-reiter
                    :gp="id"
                    :defaultGP="firma"
                    :gptyp="'firma'"
                    :editable="editable"
                    :shown="anzeige == 1 ? true : false"
                  />
                </div>

                <div v-show="anzeige === 2">
                  <bankverbindung-reiter
                    :person="id"
                    :editable="editable"
                    :initial-bankverbindungen="bankverbindungen"
                    @updatebankverbindung="bankverbindungeaendert"
                    :shown="anzeige == 2 ? true : false"
                  />
                </div>

                <div v-show="anzeige === 3">
                  <rechnung-ausgangliste
                    :firma="id"
                    :editable="editable"
                    :shown="anzeige == 3 ? true : false"
                  />
                </div>

                <div v-show="anzeige === 4">
                  <korrespondenzliste
                    :gptyp="'firma'"
                    :firma="id"
                    :editable="editable"
                    :shown="anzeige == 4 ? true : false"
                  />
                </div>

                <div v-show="anzeige === 5">
                  <mailliste
                    :firma="id"
                    :mailadressen="mailadressen"
                    :editable="editable"
                    :shown="anzeige == 5 ? true : false"
                    :key="mailkey"
                    @confirmed="maillisteUpdated"
                  />
                </div>

                <div v-show="anzeige === 6">
                  <dokumentenliste
                    :firma="id"
                    :gptyp="'firma'"
                    :dokumentEditable="editable"
                    :shown="anzeige == 6 ? true : false"
                    :key="componentKey"
                    @updateComponent="updateDokumentenliste"
                  />
                </div>

                <div v-show="anzeige === 7">
                  <notizen-liste
                    :firma="firma"
                    :editable="editable"
                    :shown="anzeige == 7 && firma.id ? true : false"
                  />
                </div>
                  <div v-show="anzeige === 8">
                  <voucher
                    :firma="firma"
                    :editable="editable"
                    :shown="anzeige == 8 ? true : false"
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid == true ? null : speichern"
      />
    </ValidationObserver>

    <!-- MODALS -->

    <loeschen-modal id="firma-loeschen-modal" @confirmed="firmaLoeschen" />

    <messagebox
      id="dupletten-msg-box"
      ref="duplettenMsgBox"
      :header-text="$t('global.duplicatesfound')"
      ok
      cancel
      repeat
      :repeat-text="$t('global.openduplicate')"
      @ok="speichern(true)"
      @repeat="oeffneDuplette"
    >
      <p>
        {{ $t("global.companyalreadyexists") }}
      </p>
      <div class="row"></div>
    </messagebox>

    <loading-overlay v-show="loading"></loading-overlay>

    <audit-log-panel
      v-if="berechtigungen.m_auditlog && berechtigungen.m_auditlog.read"
      ref="auditLogPanel"
      :firma-id="id"
      :subtitle="firma.name"
      :lookup-map="auditLookupMap"
    />
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu";
import Navbar from "@/components/Navbar";
import AuditLogPanel from "@/components/global/AuditLogPanel.vue";
import AuditLookupMap from "@/mixins/AuditLookupMap";

import Firmenangaben from "@/newviva/components/Kacheln/Firma/Firmenangaben.vue";
import Standorte from "@/components/Geschaeftspartner/Standorte.vue";
import Abteilungen from "@/components/Geschaeftspartner/Abteilungen.vue";
import Kommunikationsangaben from "@/newviva/components/Kacheln/Firma/Kommunikationsangaben.vue";

import Familienangaben from "@/newviva/components/Kacheln/Firma/Familienangaben.vue";
import Betriebsangaben from "@/newviva/components/Kacheln/Firma/Betriebsangaben.vue";
import AllgemeineEinsatzangaben from "@/newviva/components/Kacheln/Firma/AllgemeineEinsatzangaben.vue";
import InterneAngaben from "@/newviva/components/Kacheln/Firma/InterneAngaben.vue";
import WeitereAngaben from "@/newviva/components/Kacheln/Firma/WeitereAngaben.vue";
import Zeitbetriebsangaben from "@/newviva/components/Kacheln/Firma/Zeitbetriebsangaben.vue";
import Schulpartnerschaft from "@/newviva/components/Kacheln/Firma/Schulpartnerschaft.vue";

// import ZusatzangabenFirma from "@/components/Geschaeftspartner/ZusatzangabenFirma.vue";

import Kontaktreiter from "@/pages/Geschaeftspartner/Kontaktreiter";
import BankverbindungReiter from "@/pages/Geschaeftspartner/BankverbindungReiter";
import Dokumentenliste from "@/components/Reiter/Dokumentenliste";

import Korrespondenzliste from "@/components/Reiter/Korrespondenzliste";
import Mailliste from "@/components/Reiter/Mailliste";

import BeziehungReiter from "@/pages/Geschaeftspartner/BeziehungReiter.vue";

import RechnungAusgangliste from "@/components/Reiter/RechnungAusgangliste.vue";
import NotizenListe from "@/components/Reiter/Notizenliste.vue";
import Voucher from "@/newviva/components/Kacheln/Firma/Voucher.vue";

import LoeschenModal from "@/components/Modals/LoeschenModal";
import { pdfFileName } from "@/models/Beleg";

import { apiErrorToAlert } from "@/utils/Errorhandler";

import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import store from "@/store";

import { LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER } from "@/store/geschaeftspartner/actions.type";

import page from "@/mixins/Page";
import ChangeWatcherNew from "@/mixins/ChangewatcherNew";
import UnsavedChangesModal from "@/components/Modals/UnsavedChangesModal.vue";
import { LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA } from "@/store/agriviva-firma/actions.type";

export default {
  name: "FirmaNewViva",
  components: {
    HeadMenu,
    Navbar,
    AuditLogPanel,

    Firmenangaben,
    // Standorte,
    // Abteilungen,
    Kommunikationsangaben,
    Familienangaben,
    Betriebsangaben,
    AllgemeineEinsatzangaben,
    InterneAngaben,
    WeitereAngaben,
    // ZusatzangabenFirma,
    Kontaktreiter,
    Korrespondenzliste,
    Voucher,
    Mailliste,
    BeziehungReiter,
    BankverbindungReiter,
    RechnungAusgangliste,
    NotizenListe,
    Dokumentenliste,
    LoeschenModal,
    UnsavedChangesModal,
    Zeitbetriebsangaben,
    Schulpartnerschaft,
  },
  mixins: [page, ChangeWatcherNew, AuditLookupMap],
  store,
  props: {
    id: {
      type: String,
      default: null,
    },
    anzeige: {
      type: Number,
      default: 0,
    },
    rolleProp: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      editable: false,

      firma: {
        nicht_subventioniert: false,
        interesse: [],
        versand: [],
        abteilungen: [],
        standorte: [],
        branche: null,
        anrede: { id: "174BF5D05F2", bezeichnung: "Formell" },
        aktivitaetsstatus: {
          id: "1737FA777AA",
          status: 0,
          bezeichnung: "Aktiv",
        },
        hofangaben: {},
        mailadressen: [],
        bemerkungen: "",
        zeitbetriebsangaben: {},
      },
      kontaktkey: 0,
      mailkey: 0,
      anmeldungkey: 0,
      personalAngabenKey: 0,

      roles: {
        isStudent: false,
        isDozent: false,
        isMitarbeiter: false,
        isInteressent: false,
        isAlumni: false,
        isDiplomarbeiten: false,
        isReferent: false,
        isKursteilnehmer: false,
        isLieferant: false,
        isTraegerschaft: false,
        isTeilnehmerInfoabend: false,
        isArbeitgeber: false,
        isJobCoach: false,
        isPraxisbildner: false,
        isIVBerater: false,
        isNotfallkontakt: false,
        isAnstaltsdirektor: false,
        isNichtZugeordnet: false,
      },
      defaultZeitbetriebsangaben: {
        id: null,
        sanitaereEinrichtung: [],
        erreichbarkeit: "",
        weiterePersonen: "",
        weiterePersonenBemerkung: "",
        hatElektrizitaet: false,
      },
      nummer: null,
      isAdmin: false,
      // isZeitbetrieb: false,

      rolle: this.rolleProp ? [this.rolleProp] : [],

      adressen: [],
      mailadressen: [],
      bankverbindungen: [],

      dupletten: [],
      componentKey: 0,
    };
  },
  computed: {
    navbarTitel: function () {
      if (this.firma.id) {
        return `${this.$t("global.company")} #${
          this.firma.firmennummer || ""
        } ${this.firma.name}`;
      } else {
        return this.$t("global.newcompany");
      }
    },

    rolleObj() {
      if (this.firma.rollen && this.partnerrollen) {
        return this.partnerrollen.find((r) => r.id === this.firma.rollen[0]);
      }

      return null;
    },
    auswahlwerte: {
      get() {
        return this.$store.state.geschaeftspartner;
      },
    },
    partnerrollen: {
      get() {
        return this.$store.state.geschaeftspartner.partnerrollen;
      },
    },
    aktivitaetsstati: {
      get() {
        return this.$store.state.geschaeftspartner.aktivitaetsstati;
      },
    },
    auswahlwertheFirmaAgriviva: {
      get() {
        return this.$store.state.agrivivaFirma;
      },
    },
    isZeitbetrieb() {
      return this.firma.rollen && this.firma.rollen.includes("1870DABBDD9");
    },
    isPartnerschule() {
      return this.firma.rollen && this.firma.rollen.includes("1980A3E8107");
    },

    pdfFilename() {
      if (!this.selectedBeleg) return "";
      return pdfFileName(this.selectedBeleg);
    },
  },
  watch: {
    firma: {
      deep: true,
      handler: function (val) {
        console.log(`Firma changed:, ${val.zeitbetriebsangaben}`);
      },
    },
    id: {
      handler: function (val) {
        if (val) {
          this.ladeFirma(val);
        } else this.editable = this.berechtigungen.m_geschaeftspartner.create;
      },
      immediate: true,
    },
    /*
    ["person.bild"]: {
      handler: function (val) {
        if (val) {
          this.personalAngabenKey++;
        }
      },
      immediate: true,
    },
    */
  },
  mounted: function () {
    if (this.partnerrollen.length == 0)
      this.$store.dispatch(
        `geschaeftspartner/${LADE_AUSWAHLWERTE_GESCHAEFTSPARTNER}`
      );
    if (this.auswahlwertheFirmaAgriviva == null)
      this.$store.dispatch(`agrivivaFirma/${LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA}`);

    this.isAdmin =
      this.gruppen.findIndex(
        (gruppe) => gruppe.id === this.$CONST("GRUPPEN").ADMIN
      ) !== -1;
  },
  methods: {
    maillisteUpdated() {
      this.mailkey++;
      this.anmeldungkey++;
      this.kontaktkey++;
    },
    mailAdresseHinzufuegen(mailadressen) {
      this.mailadressen = mailadressen;
    },
    computeRoles(rollen) {
      this.firma.rollen = rollen;

      if (rollen) {
        let roles = {
          isStudent: false,
          isDozent: false,
          isMitarbeiter: false,
          isInteressent: false,
          isAlumni: false,
          isDiplomarbeiten: false,
          isReferent: false,
          isKursteilnehmer: false,
          isLieferant: false,
          isTraegerschaft: false,
          isTeilnehmerInfoabend: false,
          isArbeitgeber: false,
          isJobCoach: false,
          isPraxisbildner: false,
          isIVBerater: false,
          isNotfallkontakt: false,
          isAnstaltsdirektor: false,
          isNichtZugeordnet: false,
        };

        let SETUP_ROLLEN = this.$CONST("ROLLEN");

        rollen.forEach(function (selectedRole) {
          roles.isStudent =
            SETUP_ROLLEN.STUDENTEN.findIndex((role) => role == selectedRole) !=
            -1
              ? true
              : roles.isStudent;
          roles.isTeilnehmerInfoabend =
            SETUP_ROLLEN.TEILNEHMER_INFOEVENT.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isTeilnehmerInfoabend;
          roles.isDozent =
            SETUP_ROLLEN.DOZENTEN.findIndex((role) => role == selectedRole) !=
            -1
              ? true
              : roles.isDozent;
          roles.isMitarbeiter =
            SETUP_ROLLEN.MITARBEITER.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isMitarbeiter;
          roles.isInteressent =
            SETUP_ROLLEN.INTERESSENTEN.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isInteressent;
          roles.isAlumni =
            SETUP_ROLLEN.ALUMNIS.findIndex((role) => role == selectedRole) != -1
              ? true
              : roles.isAlumni;
          roles.isKursteilnehmer =
            SETUP_ROLLEN.KURSTEILNEHMER.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isKursteilnehmer;
          roles.isDiplomarbeiten =
            SETUP_ROLLEN.DIPLOMARBEIT.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isDiplomarbeiten;
          roles.isTraegerschaft =
            SETUP_ROLLEN.TRAEGERSCHAFT.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isTraegerschaft;
          roles.isLieferant =
            SETUP_ROLLEN.LIEFERANTEN.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isLieferant;
          roles.isReferent =
            SETUP_ROLLEN.REFERENTEN.findIndex((role) => role == selectedRole) !=
            -1
              ? true
              : roles.isReferent;
          roles.isArbeitgeber =
            SETUP_ROLLEN.ARBEITGEBER.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isArbeitgeber;
          roles.isJobCoach =
            SETUP_ROLLEN.JOBCOACH.findIndex((role) => role == selectedRole) !=
            -1
              ? true
              : roles.isJobCoach;
          roles.isPraxisbildner =
            SETUP_ROLLEN.PRAXISBILDNER.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isPraxisbildner;
          roles.isIVBerater =
            SETUP_ROLLEN.IVBERATER.findIndex((role) => role == selectedRole) !=
            -1
              ? true
              : roles.isIVBerater;
          roles.isNotfallkontakt =
            SETUP_ROLLEN.NOTFALLKONTAKT.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isNotfallkontakt;
          roles.isAnstaltsdirektor =
            SETUP_ROLLEN.ANSTALTSDIREKTOR.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isAnstaltsdirektor;
          roles.isNichtZugeordnet =
            SETUP_ROLLEN.NICHTZUGEORDNET.findIndex(
              (role) => role == selectedRole
            ) != -1
              ? true
              : roles.isNichtZugeordnet;
        });

        this.roles = roles;
      }
    },

    commChanged(data) {
      this.firma.telefonG = data.g;
    },

    getBildUrl() {
      if (this.firma.bild ? this.firma.bild.includes("files") : false) {
        return this.$CONST("CONFIG").BASEURL + this.firma.bild;
      } else {
        return null;
      }
    },

    kontaktegeaendert(data) {
      if (!data) return;
      this.mailadressen = data.mailadressen;
      this.adressen = data.adressen;

      //this.flagchanged();
    },

    bankverbindungeaendert(data) {
      if (!data) return;
      this.bankverbindungen = data.bankverbindungen;

      //this.flagchanged();
    },

    qualifikationenGeaendert(data) {
      if (!data) return;

      this.qualifikationen = data.qualifikationen;

      //this.flagchanged();
    },

    ladeFirma(id) {
      this.loading = true;
      AppApi.get("agriviva-firma/maske/", { params: { id: id } }).then(
        (response) => {
          this.initializeFirma(response.data);
        }
      );
    },

    neueMail() {
      let json = {
        firma: [this.firma],
        zeitpunkt: new Intl.DateTimeFormat("de-CH").format(new Date()),
      };

      Api.post("mail/", json, { params: {} }).then((response) => {
        this.$router.push({
          name: "mail",
          params: {
            id: response.data.id,
            anzeige: 0,
          },
        });
      });
    },
    neueKorrespondenz() {
      let json = {
        versand: {
          erstelltvon: this.angemeldeterMitarbeiter.person,
          datum: new Intl.DateTimeFormat("ch-DE").format(new Date()),
          betreff: "Neue Korrespondenz",
          unterschrift1: {
            person: { personName: this.$t("global.notlinked") },
          },
          unterschrift2: {
            person: { personName: this.$t("global.notlinked") },
          },
          inhalt: "",
        },
        empfaenger: [this.id],
        firma: [this.id],
        //anmeldung: this.anmeldung,
      };

      Api.post("korrespondenz/", json).then((response) => {
        this.$router.push({
          name: "korrespondenz",
          params: {
            id: response.data.id,
            anzeige: 0,
          },
        });
      });
    },
    abbrechen() {
      this.$router.push({ name: "FirmenlisteNewViva" });
    },

    neueAnmeldung() {
      this.$router.push({
        name: "anmeldung.firma",
        params: {
          firmaid: this.id,
        },
      });
    },

    initializeFirma(firma) {
      if (firma) {
        if (
          firma.aktivitaetsstatus?.id ==
          this.$CONST("AKTIVITAETSSTATI").ARCHIVIERT
        )
          this.editable = false;

        this.firma = firma;

        if (!this.firma.hofangaben) {
          this.firma.hofangaben = {};
        }

        // this.firma.bildUrl = this.getBildUrl();

        if (!this.mailadressen || this.mailadressen.length === 0) {
          this.mailadressen = firma.mailadressen;
        }

        this.bankverbindungen = firma.bankverbindungen || [];

        let roles = [];
        if (this.firma.rollen) {
          roles = this.firma.rollen.map((rolle) => {
            return rolle.id;
          });
        }

        this.computeRoles(roles);

        if (this.isZeitbetrieb && !this.firma.zeitbetriebsangaben) {
          this.firma.zeitbetriebsangaben = Object.assign(
            {},
            this.defaultZeitbetriebsangaben
          );
        }
      } else {
        console.error("Firma ist null");
      }

      this.editable = this.berechtigungen.m_geschaeftspartner.update;

      //this.initializeChangewatcher(["firma"]);
      this.loading = false;
    },

    speichern(force) {
      if (this.loading) return;

      this.loading = true;

      var json = Object.assign({}, this.firma);

      json.bankverbindungen = this.bankverbindungen.map((bv) => ({
        id: bv.id || null,
        bc_nr: bv.bc_nr || null,
        bankverbindung: bv.bankverbindung || null,
        kontonummer: bv.kontonummer || null,
        iban: bv.iban || null,
        delete: bv.delete || false,
      }));

      if (this.mailadressen != null)
        json.mailadressen = this.mailadressen.map((ma) => {
          return {
            id: ma.id || null,
            bezeichnung: ma.bezeichnung,
            hauptadresse: ma.hauptadresse,
            mailtyp: {
              id: ma.mailtyp?.id || null,
              bezeichnung: ma.mailtyp?.bezeichnung || null,
            },
            delete: ma.delete || false,
          };
        });

      if (this.adressen.length > 0) {
        console.log("Adressen", this.adressen);
        json.adressen = this.adressen.map((a) => {
          return {
            adressverwendungstyp: a.adressverwendungen.map((adv) => adv.id),
            adresse: {
              adressverbindungId: a.id || null,
              adressId: a.adresse.id || null,
              abteilung: a.adresse.abteilung || null,
              adresszusatz: a.adresse.adresszusatz || null,
              bemerkung: a.adresse.bemerkung || null,
              isKonkordat: a.adresse.isKonkordat || false,
              isKorrespondenz: a.adresse.isKorrespondenz || false,
              isRechnung: a.adresse.isRechnung || false,
              kanton: a.adresse.kanton || null,
              land: a.adresse.land || null,
              ort: a.adresse.ort || null,
              plz: a.adresse.plz || null,
              strasseNr: a.adresse.strasse_nr || null,
              delete: a.delete || false,
            },
          };
        });
      }

      json.korrespondenzSprache.id
        ? (json.korrespondenzSprache = json.korrespondenzSprache.id)
        : "";

      const hofangaben = json.hofangaben;

      if (hofangaben.betriebszweige) {
        hofangaben.betriebszweige = hofangaben.betriebszweige.map((e) => e.id);
      }

      if (hofangaben.bewirtschaftungsarten) {
        hofangaben.bewirtschaftungsarten = hofangaben.bewirtschaftungsarten.map(
          (e) => e.id
        );
      }

      if (hofangaben.nebenbetriebe) {
        hofangaben.nebenbetriebe = hofangaben.nebenbetriebe.map((e) => e.id);
      }

      if (hofangaben.tiere) {
        hofangaben.tiere = hofangaben.tiere.map((e) => e.id);
      }

      if (hofangaben.einsatzherkunftJugendliche) {
        hofangaben.einsatzherkunftJugendliche =
          hofangaben.einsatzherkunftJugendliche.map((e) => e.id);
      }

      if (hofangaben.auswahlEinsatzbereich) {
        hofangaben.auswahlEinsatzbereich = hofangaben.auswahlEinsatzbereich.map(
          (e) => e.id
        );
      }

      if (hofangaben.hoflage != null) {
        hofangaben.hoflage = hofangaben.hoflage.id
          ? hofangaben.hoflage.id
          : hofangaben.hoflage;
      }

      if (this.firma.status != null)
        json.status = this.firma.status.id
          ? this.firma.status.id
          : this.firma.status;

      if (this.firma.branche != null)
        json.branche = this.firma.branche.id
          ? this.firma.branche.id
          : this.firma.branche;

      if (this.firma.anrede != null)
        json.anrede = this.firma.anrede.id
          ? this.firma.anrede.id
          : this.firma.anrede;

      if (this.firma.interesse != null)
        json.interesse = this.firma.interesse.map((i) => {
          return i.id ? i.id : i;
        });

      this.firma.hofangaben.bemerkungIntern;

      this.firma.hofangaben.eigenesZimmer;

      this.firma.hofangaben.zimmerteilungDetails;

      this.firma.hofangaben.vereinsmitgliedAgriviva;

      // json.versand = this.firma.versand.map((v) => {
      //   return v.id ? v.id : v;
      // });

      /*json.fach = this.person.fach.map((f) => {
        return f.id;
      });*/

      // Schulpartnerschaft
      if (json.schulpartnerschaft) {
        json.reservationsfensterVon = json.schulpartnerschaft.reservationsfensterVon || null;
        json.reservationsfensterBis = json.schulpartnerschaft.reservationsfensterBis || null;
        json.partnerhofIds = (json.schulpartnerschaft.partnerhoefe || []).map((h) => h.id);
        delete json.schulpartnerschaft;
      }

      this.dupletten = [];

      if (!this.id) {
        AppApi.post("agriviva-firma/maske/", json)
          .then((response) => {
            this.initializeFirma(response.data);
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.companysuccessfullysaved"),
            });

            this.$router.replace({
              name: "FirmaNewViva",
              params: { id: response.data.id, anzeige: 0 },
            });
          })
          .catch((e) => {
            switch (e.response.status) {
              case 409:
                this.dupletten = e.response.data.dupletten;
                this.$refs.duplettenMsgBox.openModal();
                break;
              default:
                this.$notify(apiErrorToAlert(e));
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        AppApi.put("agriviva-firma/maske/", json)
          .then((response) => {
            this.initializeFirma(response.data);
            this.kontaktkey++;
            this.adressen = []; // Bewusst leer machen damit neue Adressen nicht dupliziert werden

            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.companysuccessfullysaved"),
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    oeffneDuplette() {
      if (this.dupletten.length > 0) {
        let id = this.dupletten[0].id;
        let route = this.$router.resolve({
          name: "GeschaeftspartnerMitIdUndAnzeige",
          params: { id: id, anzeige: 0 },
        });
        let win = window.open(route.href, "_blank");
        win.focus();
      }
    },

    updateDokumentenliste() {
      this.componentKey++;
    },

    firmaLoeschen() {
      AppApi.delete("agriviva-firma/maske/", {
        data: [this.id],
      }).then(() => {
        this.$router.push({ name: "FirmenlisteNewViva" });
      });
    },

    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "firma-loeschen-modal");
    },
    abteilungLoeschen(abteilung) {
      this.firma.abteilungen = this.firma.abteilungen.filter(
        (element) => element !== abteilung
      );
    },
    abteilungHinzufuegen() {
      this.firma.abteilungen.push({ id: "", bezeichnung: "" });
    },
    standortLoeschen(standort) {
      this.firma.standorte = this.firma.standorte.filter(
        (element) => element !== standort
      );
    },
    standortHinzufuegen() {
      this.firma.standorte.push({ id: "", bezeichnung: "" });
    },
  },
};
</script>

<style></style>
